exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title-responsive[data-v-54f04db3] {\n    margin-top: 1.5rem;\n}\n@media (max-width: 768px) {\n.title-responsive[data-v-54f04db3] {\n    font-size: 24px;\n    margin-bottom: -10px;\n    margin-top: 1rem;\n}\n.height[data-v-54f04db3] {\n    height: auto;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54f04db3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/StoragePage.vue
// module id = 1699
// module chunks = 0